import { HttpResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { FeatureSubsc } from '@app/models/feature-subsc';
import { I18nService } from '@core/services/i18n/i18n.service';
import { DEFAULT_LOCALE_LANG, LocaleLang } from '@core/services/i18n/locale-lang.enum';
import { AuthService } from '@services/auth.service';
import DOMPurify from 'dompurify';
import { Observable, Subject, lastValueFrom } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Injectable()
export class BaseComponent implements OnDestroy {
  stop$ = new Subject<void>();

  grpSubsc!: FeatureSubsc;
  attrCfg!: Record<string, string>;
  currLang: LocaleLang = DEFAULT_LOCALE_LANG;

  constructor(public authService: AuthService, public i18nService: I18nService) {
    this.i18nService.currentLang$.subscribe(lang => {
      this.currLang = lang;
    });
    this.authService.grpSubscptSubject.pipe(takeUntil(this.stop$)).subscribe(grpSubsc => {
      this.grpSubsc = grpSubsc;
    });
    this.authService.attrCfgSubject.pipe(takeUntil(this.stop$)).subscribe(attrCfg => {
      this.attrCfg = attrCfg;
    });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  async handleDownloadResponse(response: Observable<HttpResponse<Blob>>, defaultFileName: string) {
    if (response) {
      const res: { blobData: any; filename: string } = await lastValueFrom(
        response
          .pipe(
            map((response: any) => {
              const disposition = response.headers.get('Content-Disposition');
              if (disposition) {
                defaultFileName = disposition.split('filename=')[1];
              }
              return { blobData: response.body, filename: defaultFileName };
            }),
          )
          .pipe(takeUntil(this.stop$)),
      );
      if (!res) return;
      const { blobData, filename } = res;
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blobData);
      a.href = objectUrl;
      a.download = DOMPurify.sanitize(decodeURIComponent(filename));
      a.click();
      URL.revokeObjectURL(objectUrl);
    }
  }
}
